import React from 'react';
import YouTube from 'react-youtube';

interface YoutubeEmbedProps {
  videoId: string;
}

export const YoutubeEmbed: React.FC<YoutubeEmbedProps> = ({ videoId }) => {
  return <YouTube opts={{ width: '100%', height: '400' }} videoId={videoId} />;
};
